export default {
  unexpected_error: 'Something went wrong. Please try again later',
  network_error: 'It seems there is a problem with network connection. Please try again later',
  server_error: 'Unfortunately, our servers are temporarily unavailable. Please try again later',
  complete_required_fields: 'Please fill out all the fields correctly before continuing'
}



// WEBPACK FOOTER //
// ./src/js/i18n/to_replace/default.js